import { useCallback } from "react";
import { useSelector } from "react-redux";

import { getIsPlaceholderNodeSelector, getNodeTitleByIdSelector } from "../state/index.ts";

export const useGetNodeTitleAndIsPlaceholder = () => {
  const getNodeTitle = useSelector(getNodeTitleByIdSelector);
  const getIsPlaceholder = useSelector(getIsPlaceholderNodeSelector);

  return useCallback(
    (id: number) => {
      const title = getNodeTitle(id);
      const isPlaceholder = getIsPlaceholder(id);
      if (!title) {
        console.error(`Title requested for node id ${id} but not provided (getTitle).`);
        return { title: `Untitled (${id}).`, isPlaceholder };
      }
      return {
        title,
        isPlaceholder,
        // node.childNodes.content && "isPlaceholder" in node.childNodes.content && node.childNodes.content.isPlaceholder,
      };
    },
    [getIsPlaceholder, getNodeTitle],
  );
};
